var map = {
	"./domek-serwy.jpg": 5850,
	"./headers/krzysiek.jpg": 1709,
	"./headers/serwy.jpg": 4417,
	"./headers/u-ani.jpg": 5299,
	"./pokoje-u-ani.jpg": 1100,
	"./pokoje-u-krzysk_a.jpg": 3244,
	"./pokoje-u-krzyska-2.jpg": 9740,
	"./pokoje_krzyska/domek_4_osobowy/image_1.jpg": 1217,
	"./pokoje_krzyska/domek_4_osobowy/image_2.jpg": 5952,
	"./pokoje_krzyska/domek_4_osobowy/image_3.jpg": 9178,
	"./pokoje_krzyska/domek_4_osobowy/image_4.jpg": 564,
	"./pokoje_krzyska/mieszkanie_5_osobowe/image_1.jpg": 8329,
	"./pokoje_krzyska/mieszkanie_5_osobowe/image_2.jpg": 3632,
	"./pokoje_krzyska/mieszkanie_5_osobowe/image_3.jpg": 677,
	"./pokoje_krzyska/mieszkanie_5_osobowe/image_4.jpg": 1433,
	"./pokoje_krzyska/mieszkanie_5_osobowe/image_5.jpg": 2963,
	"./pokoje_krzyska/mieszkanie_5_osobowe/image_6.jpg": 3589,
	"./pokoje_krzyska/mieszkanie_5_osobowe/image_7.jpg": 2352,
	"./pokoje_krzyska/outside/image_1.jpg": 4514,
	"./pokoje_krzyska/outside/image_10.jpg": 4052,
	"./pokoje_krzyska/outside/image_2.jpg": 410,
	"./pokoje_krzyska/outside/image_3.jpg": 8708,
	"./pokoje_krzyska/outside/image_4.jpg": 3118,
	"./pokoje_krzyska/outside/image_5.jpg": 1002,
	"./pokoje_krzyska/outside/image_6.jpg": 8497,
	"./pokoje_krzyska/outside/image_7.jpg": 2988,
	"./pokoje_krzyska/outside/image_8.jpg": 8309,
	"./pokoje_krzyska/outside/image_9.jpg": 905,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_1.jpg": 4999,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_10.jpg": 5209,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_11.jpg": 7063,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_2.jpg": 9315,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_3.jpg": 4476,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_4.jpg": 8134,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_5.jpg": 8174,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_6.jpg": 7417,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_7.jpg": 387,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_8.jpg": 664,
	"./pokoje_krzyska/pokoje_2-3_osobowe/image_9.jpg": 9798,
	"./pokoje_krzyska/pokoje_2_osobowe/image_1.jpg": 5936,
	"./pokoje_krzyska/pokoje_2_osobowe/image_2.jpg": 2817,
	"./pokoje_krzyska/pokoje_2_osobowe/image_3.jpg": 4252,
	"./pokoje_krzyska/pokoje_2_osobowe/image_4.jpg": 2583,
	"./pokoje_krzyska/pokoje_2_osobowe/image_5.jpg": 6266,
	"./pokoje_krzyska/pokoje_2_osobowe/image_6.jpg": 4749,
	"./pokoje_krzyska/pokoje_3-4_osobowe/image_1.jpg": 2753,
	"./pokoje_krzyska/pokoje_3-4_osobowe/image_2.jpg": 6499,
	"./pokoje_krzyska/pokoje_3-4_osobowe/image_3.jpg": 6990,
	"./pokoje_krzyska/pokoje_3-4_osobowe/image_4.jpg": 7160,
	"./pokoje_krzyska/pokoje_3-4_osobowe/image_5.jpg": 6141,
	"./pokoje_krzyska/pokoje_3-4_osobowe/image_6.jpg": 6214,
	"./pokoje_krzyska/pokoje_3-4_osobowe/image_7.jpg": 7201,
	"./pokoje_u_ani/outside/image_1.jpg": 6687,
	"./pokoje_u_ani/outside/image_10.jpg": 9473,
	"./pokoje_u_ani/outside/image_11.jpg": 5097,
	"./pokoje_u_ani/outside/image_12.jpg": 1033,
	"./pokoje_u_ani/outside/image_13.jpg": 4831,
	"./pokoje_u_ani/outside/image_14.jpg": 4742,
	"./pokoje_u_ani/outside/image_2.jpg": 2617,
	"./pokoje_u_ani/outside/image_3.jpg": 4308,
	"./pokoje_u_ani/outside/image_4.jpg": 3616,
	"./pokoje_u_ani/outside/image_5.jpg": 3617,
	"./pokoje_u_ani/outside/image_6.jpg": 3338,
	"./pokoje_u_ani/outside/image_7.jpg": 9359,
	"./pokoje_u_ani/outside/image_8.jpg": 3410,
	"./pokoje_u_ani/outside/image_9.jpg": 6857,
	"./pokoje_u_ani/pokoj_4_osobowy/image_1.jpg": 3979,
	"./pokoje_u_ani/pokoj_4_osobowy/image_2.jpg": 4816,
	"./pokoje_u_ani/pokoj_4_osobowy/image_3.jpg": 6419,
	"./pokoje_u_ani/pokoj_4_osobowy/image_4.jpg": 663,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_1.jpg": 837,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_10.jpg": 8033,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_2.jpg": 8781,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_3.jpg": 6747,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_4.jpg": 5389,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_5.jpg": 1662,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_6.jpg": 71,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_7.jpg": 3645,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_8.jpg": 3071,
	"./pokoje_u_ani/pokoje_2-3_osobowe/image_9.jpg": 8602,
	"./pokoje_u_ani/pokoje_2_osobowe/image_1.jpg": 6691,
	"./pokoje_u_ani/pokoje_2_osobowe/image_2.jpg": 6762,
	"./pokoje_u_ani/pokoje_2_osobowe/image_3.jpg": 59,
	"./pokoje_u_ani/pokoje_2_osobowe/image_4.jpg": 1204,
	"./pokoje_u_ani/pokoje_2_osobowe/image_5.jpg": 2277,
	"./pokoje_u_ani/pokoje_2_osobowe/image_6.jpg": 7926,
	"./pokoje_u_ani/pokoje_2_osobowe/image_7.jpg": 8764,
	"./pokoje_u_ani/pokoje_2_osobowe/image_8.jpg": 337,
	"./serwy/dom/image_1.jpg": 9049,
	"./serwy/dom/image_10.jpg": 9376,
	"./serwy/dom/image_11.jpg": 7707,
	"./serwy/dom/image_12.jpg": 4324,
	"./serwy/dom/image_2.jpg": 2915,
	"./serwy/dom/image_3.jpg": 5219,
	"./serwy/dom/image_4.jpg": 8784,
	"./serwy/dom/image_5.jpg": 9114,
	"./serwy/dom/image_6.jpg": 8818,
	"./serwy/dom/image_7.jpg": 7557,
	"./serwy/dom/image_8.jpg": 6840,
	"./serwy/dom/image_9.jpg": 4537,
	"./serwy/domek/image_1.jpg": 9349,
	"./serwy/domek/image_2.jpg": 223,
	"./serwy/domek/image_3.jpg": 8433,
	"./serwy/domek/image_4.jpg": 6176,
	"./serwy/domek/image_5.jpg": 4227,
	"./serwy/domek/image_6.jpg": 3069,
	"./serwy/domek/image_7.jpg": 2245,
	"./serwy/domek/image_8.jpg": 1682,
	"./serwy/outside/image_1.jpg": 7888,
	"./serwy/outside/image_10.jpg": 6776,
	"./serwy/outside/image_11.jpg": 6551,
	"./serwy/outside/image_12.jpg": 3443,
	"./serwy/outside/image_2.jpg": 567,
	"./serwy/outside/image_3.jpg": 8767,
	"./serwy/outside/image_4.jpg": 2253,
	"./serwy/outside/image_5.jpg": 783,
	"./serwy/outside/image_6.jpg": 2402,
	"./serwy/outside/image_7.jpg": 8080,
	"./serwy/outside/image_8.jpg": 5176,
	"./serwy/outside/image_9.jpg": 4352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1797;